import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsArtstationComponent } from './simple-icons-artstation.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsArtstationComponent ],
    exports:      [ SimpleIconsArtstationComponent ],
    bootstrap:    []
})
export class SimpleIconsArtstationModule {}
